import { render, staticRenderFns } from "./pdfReader_token.vue?vue&type=template&id=9ddc9f8e&scoped=true&"
import script from "./pdfReader_token.vue?vue&type=script&lang=js&"
export * from "./pdfReader_token.vue?vue&type=script&lang=js&"
import style0 from "./pdfReader_token.vue?vue&type=style&index=0&id=9ddc9f8e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ddc9f8e",
  null
  
)

export default component.exports